const _ = require('lib/underscore')
const Backbone = require('lib/backbone')
const BaseElement = require('./element.base')


const SelectElement = BaseElement.extend({

    validateConstructor(attrs) {
        if (! attrs.values) throw new Error('Select Element requires a list of values.')

        // ensure that `values` is a collection
        if (_.isArray(attrs.values)) {
            attrs.values = new Backbone.Collection(attrs.values)
        }
        if (! (attrs.values instanceof Backbone.Collection)) {
            throw new Error('Select Element requires a list of values.')
        }
        return attrs
    },

    initializeElement() {
        this.setSelectedOption()
        this.on('change:value', this.setSelectedOption)
    },

    setSelectedOption() {
        // set selected to true on first options with same value
        const values = this.get('values')
        values.each((value) => {
            value.unset('selected')
        })
        const same_value = values.findWhere({ value: this.get('value') })
        if (same_value) same_value.set('selected', true)
    },

})

module.exports = SelectElement
